import { css } from "@compiled/react";
import { useLocalizedHref } from "@libraries/web-framework";

import AccountCreation, { Social } from "@/components/signup/account-creation";
import {
    getWacIntegrationUrl,
    SocialProvider
} from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";
import { experiments, useExperiment } from "@/utils/experiment";

export type SignUpFormTextColor = "default" | "light";

export type UniformSignUpProps = {
    socialProviders?: SocialProvider[];
    textColor?: SignUpFormTextColor;
};

export const transformProviders = (providerList: string[]) => {
    return providerList.reduce(
        (previous, key) => ({ ...previous, [key.toLowerCase()]: key }),
        {}
    );
};

const lightTextColorCss = css({
    color: wacToken("color.neutral.light0")
});

const UniformSignUpForm = ({
    socialProviders,
    textColor = "default"
}: UniformSignUpProps) => {
    const jiraPlusExperiment = useExperiment(experiments.twcg1444JiraPlusOptIn);

    const jiraPlusPage = useLocalizedHref("/software/jira/free");

    const getContinueUrl: () => string | undefined = () => {
        if (jiraPlusExperiment.type === "enrolled") {
            jiraPlusExperiment.fireExposure();
            if (jiraPlusExperiment.value) {
                return `${getWacIntegrationUrl()}${jiraPlusPage}`;
            }
        }
    };

    return (
        <div css={[textColor === "light" && lightTextColorCss]}>
            <AccountCreation
                getContinueUrl={getContinueUrl}
                Login={null}
                Social={
                    socialProviders?.length ? (
                        <Social
                            providers={transformProviders(socialProviders)}
                        />
                    ) : undefined
                }
            />
        </div>
    );
};

export default UniformSignUpForm;
